<template>
  <BaseCircleButton
    size="lg"
    @click="favorite.toggleFavorite(artwork._id)"
    :disabled="favorite.loading"
    rounded="rounded-full"
    variant="transparent"
    :title="
      favorite.favoriteIds.includes(artwork._id)
        ? $t('artwork_details.in_favorites')
        : $t('artwork_details.add_favorite')
    "
  >
    <Icon
      name="ph:heart-fill"
      v-if="favorite.loading"
      class="animate-pulse text-rose-400 sm:size-6 size-5"
    />
    <Icon
      v-else
      :name="
        favorite.favoriteIds.includes(artwork._id)
          ? 'ph:heart-fill'
          : 'ph:heart'
      "
      :class="
        favorite.favoriteIds.includes(artwork._id)
          ? 'text-rose-600'
          : 'text-black'
      "
      class="sm:size-6 size-5"
    />
  </BaseCircleButton>
</template>

<script setup lang="ts">
import type { Artwork } from "~~/types/artwork";
defineProps<{
  artwork: Artwork;
}>();

const favorite = useFavoriteStore();
</script>
